export default {
  API_ENDPOINT: `https://sheltered-brushlands-82423.herokuapp.com/api`,
  API_KEY: process.env.REACT_APP_API_KEY,
}